import { Header, Main, Page, Site } from './AppContainer.style';
import AppHeader from './components/AppHeader';

export default function AppContainer({ children }) {
  return (
    <Site>
      <Page>
        <Header>
          <AppHeader />
        </Header>
        <Main>{children}</Main>
      </Page>
    </Site>
  );
}
